// extracted by mini-css-extract-plugin
export default {"corporateAccountsModalForm":"MWA4V5iXZO0i_DVIR_CV"};